// @flow

import {
  Mileage, Package, Duration, ClaimFree, SmallColors,
} from './atoms/choiceGroups';
import Config from './config';

export {
  Mileage,
  Duration,
  Package,
  ClaimFree,
  SmallColors,
};

export default Config;
